import { render, staticRenderFns } from "./TosfHeiPrograms.vue?vue&type=template&id=6b47aa84&scoped=true"
import script from "./TosfHeiPrograms.vue?vue&type=script&lang=js"
export * from "./TosfHeiPrograms.vue?vue&type=script&lang=js"
import style0 from "./TosfHeiPrograms.vue?vue&type=style&index=0&id=6b47aa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47aa84",
  null
  
)

export default component.exports